type PropTypes = {
  className?: string
}

const LabelLine = ({ className }: PropTypes) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 31 12"
      className={className}
    >
      <path
        fill="currentColor"
        d="M0 5.5h31v1H0z"
      />
      <path
        fill="currentColor"
        d="M30 .5h1v11h-1z"
      />
    </svg>
  )
}

export default LabelLine
